import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mapValues',
    pure: false,
    standalone: false
})
export class MapValuesPipe implements PipeTransform {

  transform(value: Map<any, any>): any {
    const returnArray = [];

    value.forEach(mapValue => {
      returnArray.push(mapValue);
    });

    return returnArray;
  }

}
